export default __webpack_public_path__ + "static/media/perksBenefitsIcon2.8b8fc8d7.png";